import React from "react";
import useStyles, {
  aboutDrawerWidth,
  aboutTogglebarWidth,
  chartTogglebarWidth,
  filterContainerHeight,
  chartTitleHeight,
} from "../Styles";
import { toolbarHeight, filterToolbarHeight } from "components/app/Styles";
import { Box, Typography, Grid } from "@material-ui/core";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highChartsTilemap from "highcharts/modules/tilemap";
import addHeatmapModule from "highcharts/modules/heatmap";
import { getWindowSize } from "../utils";
import { useSelector } from "react-redux";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import userActions from "../actions";
import { positions, aliases, reverse_aliases} from "./polymap_constants";
// import { alias_entity_id_mapping } from "./polymap_constants";

addHeatmapModule(Highcharts);
highChartsTilemap(Highcharts);
const inactiveTileOpacity = 0.2;
const activeTileOpacity = 1;
const activeTileShadowWidth = 3;

const IrrigationPolygonMap = () => {
  const classes = useStyles();
  const [windowSize, setWindowSize] = React.useState(getWindowSize());
  const { toggle_about, all_cities_metric, cities, scenario_selected } = useSelector(
    (state) => state.technical_view
  );
  const { isMobile } = useGetViewPortDimensions();
  const [options, setOptions] = React.useState({ series: [] });
  const { 
    setSelectedCity,
    loadEntityEntitlements,
    loadCityMetrics,
    loadCityWaterSources,
    setIsTribe,
    setIsWesternEntity, 
    loadAllCitiesMetric } = userActions();
  const [cityColors, setCityColors] = React.useState({}); 
  const colors = {
    1: "#2352D0", // Ground Water
    2: "#FFB607", // Salt and Verde
    3: "#DE3E40", // Aqua Fria
    //4: "#2352D0", // Colorado River
  }; //  Define Colors

  const toggledPolyMapStyle = {
    width: `calc(100vw - ${aboutTogglebarWidth}px - ${chartTogglebarWidth}px)`,
  };

  /* 
  On any mouseover action (select/hover) on a honeycomb tile, 
  the right side charts and about section information are automatically updated
  */
  const displayDetailsOnTileSelect = (entity_name) => {
    /*
    We need to find cityID in order to load city metrics by calling backend APIs
    We first find the full city name (if any) from the colloquial name from reverse_alias map
    and then find the corresponsing cityID from the cities map
    */
    var aliased_city_name =  reverse_aliases.hasOwnProperty(entity_name)
                ? reverse_aliases[entity_name]
                : entity_name;
    var cityFound = cities.find((item) => item.label === (aliased_city_name));
    var cityIdx = cityFound["value"];
    loadCityMetrics(cityIdx);
    setSelectedCity(cityFound);
    loadEntityEntitlements(cityIdx, scenario_selected.value);
    loadCityWaterSources(cityIdx);
    setIsTribe(false);
    setIsWesternEntity(false);
  }

  const componentMount = () => {
    loadAllCitiesMetric();
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }
  React.useEffect(componentMount, []);

  const setCityFunc = () => {
    let temp_city_colors = {};
    Object.keys(all_cities_metric).forEach((item) => {
      const arr = [
        all_cities_metric[item].tap_groundwater,
        all_cities_metric[item].tap_salt_and_verde,
        all_cities_metric[item].tap_agua_fria
      ];
      const max = arr.indexOf(Math.max(...arr));
      temp_city_colors[item["city_name"]] = colors[max];
    });
    setCityColors(temp_city_colors);
  }
  React.useEffect(setCityFunc, [all_cities_metric]);

  const setWindowHook = () => {
    const width = isMobile
    ? windowSize.innerWidth
    : windowSize.innerWidth -
      (toggle_about ? aboutDrawerWidth : aboutTogglebarWidth) -
      chartTogglebarWidth;
  const height = isMobile
    ? windowSize.innerHeight -
      toolbarHeight -
      filterToolbarHeight -
      chartTitleHeight -
      aboutTogglebarWidth
    : windowSize.innerHeight -
      toolbarHeight -
      chartTitleHeight -
      filterContainerHeight -
      130;
  const dim = isMobile ? Math.min(width, height) - 30 : width / 2 + 108;
  let options_temp = {
    chart: {
      type: "tilemap",
      width: dim - (isMobile ? 10 : -100),
      height: dim - (isMobile ? 40 : 35),
      plotBackgroundColor: "transparent",
      backgroundColor: "transparent",
      animation: false
    },
    title: {
      text: "",
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    legend: {
      enabled: false,
      title: {
        text: "Sources",
      },
      style: {
        fontFamily: "Arial",
      },
      itemStyle: {
        fontWeight: "lighter",
      },
      layout: "vertical",
      align: "right",
      padding: 20,
      backgroundColor: "#FFF",
      borderRadius: 10,
      itemMarginBottom: 5,
      itemMarginTop: 5,
      y: -20,
      labelFormatter: function () {
        return this.name;
      },
    },
    tooltip: {
      enabled: false,
      padding: 16,
      backgroundColor: "#FFF",
      borderRadius: 8,
      useHTML: true,
      style: { color: "#000", fontFamily: "'Arial', sans-serif" },
      // formatter() {
      //   const name = this.point.real_name;
      //   let tooltip = "";
      //   if (alias_entity_id_mapping.hasOwnProperty(name)) {
      //     const idx = alias_entity_id_mapping[name];
      //     tooltip += "<p style='line-height:12px'><b>" + name + "</b></p>";
      //     tooltip +=
      //       "<p>Ground Water: <strong>" +
      //       all_cities_metric[idx].tap_groundwater.toLocaleString("en-US") +
      //       " ac-ft</strong></p>";
      //     tooltip +=
      //       "<p>Salt and Verde: <strong>" +
      //       all_cities_metric[idx].tap_salt_and_verde.toLocaleString(
      //         "en-US"
      //       ) +
      //       " ac-ft</strong></p>";
      //     tooltip +=
      //       "<p>Agua Fria P3: <strong>" +
      //       all_cities_metric[idx].tap_agua_fria.toLocaleString("en-US") +
      //       " ac-ft</strong></p>";
      //   }
      //   return tooltip;
      // },
    },
    plotOptions: {
      series: {
        animation: false,
        pointPadding: 2,
        dataLabels: {
          enabled: true,
          color: "#000000",
          format: "{point.name}",
        },
        states: {
          hover: {
            halo: false,
            enabled: false,
          },
        },
        point: {
          events: {
              mouseOver: function () {
                  var seriesData = this.series.data;
                  //looping through all the tiles in the hovered series
                  for (var i=0; i < seriesData.length; i++) {
                    // if a tile specifically is not hovered over, make it look inactive
                    if (i!==this.index) {
                      this.series.data[i].update({opacity: inactiveTileOpacity});
                      Highcharts.each(this.series.data[i].graphic.shadows, function(p) {
                        p.remove();
                      })
                    } 
              }          
              },
              mouseOut: function () {
                var seriesData = this.series.data;
                for (var i=0; i < seriesData.length; i++) {
                  // if a tile specifically was not hovered over, restore it's original active styling
                  if (i!==this.index) {
                    this.series.data[i].update({opacity: activeTileOpacity});
                    this.series.data[i].graphic.shadow({
                      width: activeTileShadowWidth,
                      opacity: activeTileOpacity
                    })
                  }
                    
              }

              },
              click: function () {
                displayDetailsOnTileSelect(this.name);
              }
          }
      },
        shadow: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [],
  };
  let series = [
    { data: [], color: "#2352D0", name: "Ground Water" }, // Ground Water
    { data: [], color: "#FFB607", name: "Salt and Verde" }, // Salt and Verde
    { data: [], color: "#DE3E40", name: "Agua Fria" }, // Aqua Fria
  ];
  Object.keys(all_cities_metric).forEach((item, idx) => {
    if (positions.hasOwnProperty(all_cities_metric[item].city_name)) {
      const arr = [
        all_cities_metric[item].tap_groundwater,
        all_cities_metric[item].tap_salt_and_verde,
        all_cities_metric[item].tap_agua_fria,
      ];
      const max = arr.indexOf(Math.max(...arr));
      series[max].data.push({
        x: positions[all_cities_metric[item].city_name][0],
        y: positions[all_cities_metric[item].city_name][1],
        name: aliases.hasOwnProperty(all_cities_metric[item].city_name)
          ? aliases[all_cities_metric[item].city_name]
          : all_cities_metric[item].city_name,
        real_name: all_cities_metric[item].city_name,
      });
    }
    // else if (item.city_name == "Arizona Water Co. (Pinal)") {
    //   const arr = [
    //     //   item.tap_colorado,
    //     item.tap_groundwater,
    //     item.tap_salt_and_verde,
    //     item.tap_agua_fria,
    //   ];
    //   const max = arr.indexOf(Math.max(...arr));
    //   series[max].data.push({
    //     x: positions["Casa Grande"][0],
    //     y: positions["Casa Grande"][1],
    //     name: "Casa Grande",
    //     real_name: item.city_name
    //   });
    //   series[max].data.push({
    //     x: positions["Coolidge System"][0],
    //     y: positions["Coolidge System"][1],
    //     name: "Coolidge System",
    //     real_name: item.city_name,
    //   });
    // }
  });

  options_temp.series = series;
  setOptions(options_temp);
  }
  React.useEffect(setWindowHook, [windowSize, toggle_about, cityColors]);

  return (
    <>
      <Box className={classes.polymapContainer} style={toggle_about || isMobile ? null : toggledPolyMapStyle}>
        <Grid
          className={classes.highchart}
          style={!isMobile ? { marginTop: 150 } : null}
        >
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Grid>
      </Box>
      <Grid className={classes.chartLegendContainer} style={{marginBottom: 40, marginRight: 16}}>
        <Grid className={classes.chartLegend}>
          <Typography className={classes.legendTitle}>Other Sources</Typography>
          <Box className={classes.legendItems}>
            {options.series.map((item, idx) =>
              item.data.length > 0 ? (
                <Grid className={classes.legendItem}>
                  <Box
                    classes={{ root: classes.legendItemColor }}
                    style={{ backgroundColor: item.color }}
                  />
                  <Typography className={classes.legendItemText}>
                    {item.name}
                  </Typography>
                </Grid>
              ) : " "
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default IrrigationPolygonMap;
